import { safeApiRequest } from './apiClient';

export const stokV2Ara = async ({ q, sayfa = 1, limit = 50 } = {}) => {
  const params = { sayfa, limit };
  if (q && String(q).trim()) params.q = String(q).trim();
  return safeApiRequest('/api/stok/v2/ara', { method: 'GET', query: params, skipCsrf: true });
};

export const fetchTeknikServislerStokV2 = async ({ arama, sayfa = 1, limit = 30 } = {}) => {
  const params = { sayfa, limit };
  if (arama && String(arama).trim()) params.arama = String(arama).trim();
  return safeApiRequest('/api/stok/v2/teknik-servisler', { method: 'GET', query: params, skipCsrf: true });
};

export const fetchTeknikServisStokV2 = async (teknikServisId, { sayfa = 1, limit = 25, tab = 'guncel', q } = {}) => {
  const query = { sayfa, limit };
  if (tab && tab !== 'guncel') query.tab = tab;
  if (q && String(q).trim()) query.q = String(q).trim();
  return safeApiRequest(`/api/stok/v2/teknik-servis/${encodeURIComponent(teknikServisId)}`, {
    method: 'GET', query, skipCsrf: true,
  });
};

export const fetchStokBen = async ({ sayfa = 1, limit = 25, tab = 'guncel', q } = {}) => {
  const query = { sayfa, limit };
  if (tab && tab !== 'guncel') query.tab = tab;
  if (q && String(q).trim()) query.q = String(q).trim();
  return safeApiRequest('/api/stok/v2/ben', { method: 'GET', query, skipCsrf: true });
};

export const fetchStokHareketler = async (teknikServisId, icerikId, { sayfa = 1, limit = 50 } = {}) => {
  const params = { sayfa, limit };
  if (icerikId) params.icerikId = icerikId;
  return safeApiRequest(`/api/stok/v2/teknik-servis/${encodeURIComponent(teknikServisId)}/hareketler`, {
    method: 'GET', query: params, skipCsrf: true,
  });
};

export const fetchStokBenHareketler = async (icerikId, { sayfa = 1, limit = 50 } = {}) => {
  const params = { sayfa, limit };
  if (icerikId) params.icerikId = icerikId;
  return safeApiRequest('/api/stok/v2/ben/hareketler', { method: 'GET', query: params, skipCsrf: true });
};

export const stokManuelGuncelle = async ({ icerikId, adet, not }) => {
  return safeApiRequest('/api/stok/v2/ben/guncelle', {
    method: 'POST',
    body: { icerikId, adet, not },
  });
};

export const stokParcaAra = async (q) => {
  return safeApiRequest('/api/stok/v2/parca-ara', {
    method: 'GET', query: { q }, skipCsrf: true,
  });
};

export const fetchParcaSiparisOzetBen = async (icerikId, { sayfa = 1, limit = 10 } = {}) => {
  return safeApiRequest(`/api/stok/v2/ben/parca/${encodeURIComponent(icerikId)}/siparis-ozet`, {
    method: 'GET',
    query: { sayfa, limit },
    skipCsrf: true,
  });
};

export const fetchParcaSiparisOzetAdmin = async (teknikServisId, icerikId, { sayfa = 1, limit = 10 } = {}) => {
  return safeApiRequest(
    `/api/stok/v2/teknik-servis/${encodeURIComponent(teknikServisId)}/parca/${encodeURIComponent(icerikId)}/siparis-ozet`,
    { method: 'GET', query: { sayfa, limit }, skipCsrf: true }
  );
};

export const fetchOzMaliyetOzet = async (teknikServisId, icerikId) => {
  return safeApiRequest(
    `/api/stok/v2/teknik-servis/${encodeURIComponent(teknikServisId)}/parca/${encodeURIComponent(icerikId)}/oz-maliyet-ozet`,
    { method: 'GET', skipCsrf: true },
  );
};

export const konsinyeOzDonusum = async ({ teknikServisId, icerikId, adet, birimFiyat, faturaBilgisi }) => {
  return safeApiRequest('/api/stok/v2/konsinye-oz-donusum', {
    method: 'POST',
    body: { teknikServisId, icerikId, adet, birimFiyat, faturaBilgisi },
  });
};
